<script>
  let { size = 'md', class: className = '' } = $props()

  const dotSize = size === 'sm' ? 'w-1.5 h-1.5' : size === 'lg' ? 'w-2.5 h-2.5' : 'w-2 h-2'
  const gap = size === 'sm' ? 'gap-[3px]' : size === 'lg' ? 'gap-[6px]' : 'gap-[5px]'
</script>

<div
  class="loading-dots inline-flex items-center {gap} {className}"
  role="status"
  aria-label="Loading"
>
  {#each [0, 1, 2, 3] as i}
    <span
      class="loading-dot {dotSize} rounded-full bg-current motion-reduce:animate-none motion-reduce:opacity-60"
      style="animation-delay: {i * 0.12}s"
    ></span>
  {/each}
</div>

<style>
  .loading-dots {
    filter: drop-shadow(0 0 4px currentColor);
    opacity: 0.9;
  }

  .loading-dot {
    display: inline-block;
    opacity: 0.3;
    animation: loading-dot 1.4s cubic-bezier(0.4, 0, 0.2, 1) infinite;
    will-change: transform, opacity;
  }

  @keyframes loading-dot {
    0%, 70%, 100% {
      transform: translateY(0) scale(0.85);
      opacity: 0.3;
    }
    35% {
      transform: translateY(-45%) scale(1.1);
      opacity: 1;
    }
  }
</style>
